import React from 'react';
import { Controller } from 'react-hook-form';
import { Button, DeleteButton, FormGroup, TextField, TitleText, Typo } from 'components/primitives';
import { Box, Container, Grid } from '@mui/material';
import { ConfirmationModal } from 'components/modals';
import useStyles from './IncidentDetails.styles';
import { IncidentDetailsProps } from './IncidentDetails.props';
import { FormAction } from 'common/enums';

const IncidentDetailsView: React.FC<IncidentDetailsProps> = ({
  form,
  selectIncident,
  ...props
}) => {
  const classes = useStyles();
  const { control } = form;

  return (
    <React.Fragment>
      <Container>
        <TitleText title={selectIncident?.name || ''} />
        <Grid container spacing={2}>
          <Grid item xs={12} lg={12}>
            <Controller
              name={'name'}
              control={control}
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <FormGroup label='Name' error={error}>
                  <TextField
                    error={Boolean(error)}
                    placeholder='Incident name'
                    value={value}
                    onChange={onChange}
                  />
                </FormGroup>
              )}
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <Controller
              name={'description'}
              control={control}
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <FormGroup label='Description' error={error}>
                  <textarea
                    className={classes.textarea}
                    spellCheck='false'
                    rows={10}
                    value={value || ''}
                    onChange={onChange}
                  />
                </FormGroup>
              )}
            />
          </Grid>
        </Grid>
        <Box className={classes.footer}>
          <DeleteButton
            style={{minWidth: '100px'}}
            progress={props.loading && props.formStatus === FormAction.ARCHIVE}
            onClick={props.showModal}>
            Archive
          </DeleteButton>
          <div>
          <Button
            style={{marginRight: '14px', minWidth: '100px'}}
            alternate
            onClick={() => props.handleEditModal(false)}>
            Cancel
          </Button>
          <Button
            style={{minWidth: '100px'}}
            progress={props.loading && props.formStatus === FormAction.UPDATE}
            onClick={form.handleSubmit(props.onSubmit)}>
            Update
          </Button>
          </div>
        </Box>
      </Container>
      <ConfirmationModal
        open={props.confirmModal}
        loading={props.loading && props.formStatus === FormAction.ARCHIVE}
        title='Archive incident'
        onConfirm={(e, ok) => props.handleArchive(ok)}>
        <React.Fragment>
          <Typo variant='body1' sx={{ fontSize: '16px' }} color='common.black' mb={2}>
            Please confirm that you want to archive this incident.
          </Typo>
        </React.Fragment>
      </ConfirmationModal>
    </React.Fragment>
  );
};

export default IncidentDetailsView;
